export const SITE_CONFIG = {
  name: 'DIGITREK',
  title: 'DIGITREK | Digital Transformation Agency Dubai',
  description: "Dubai's digital transformation partner. We build web platforms, mobile apps, Agentic AI solutions & Odoo ERP that help businesses grow. Talk to us today.",
  url: 'https://digitrek.ae',
  email: 'info@digitrek.ae',
  phone: '+971 50 1234567',
  address: 'Life Sciences Lab, Dubai, UAE',
} as const

export const NAV_LINKS = [
  { href: '#home', label: 'Home' },
  { href: '#process', label: 'What We Do' },
  { href: '#services', label: 'Our Services' },
  // { href: '#testimonials', label: 'Testimonials' }, // Omitted for future use
  { href: '#about', label: 'About Us' },
  { href: '#contact', label: 'Get your Free Audit' },
] as const

export const SERVICES = [
  {
    id: 'web-development',
    title: 'Website Development & Digital Presence',
    description: 'Build a powerful online identity with responsive, high-performing websites.',
    icon: 'Code',
    featured: true,
  },
  {
    id: 'mobile-experience',
    title: 'Seamless Mobile Experience',
    description: 'Deliver high performing mobile apps designed for user satisfaction, and growth.',
    icon: 'Smartphone',
    featured: false,
  },
  {
    id: 'ai-solutions',
    title: 'AI-Powered Solutions',
    description: 'Integrate AI into your operations to enhance customer experiences.',
    icon: 'Brain',
    featured: false,
  },
  {
    id: 'data-insights',
    title: 'Unlocking Data Insights',
    description: 'Data-driven strategies to uncover opportunities, and accelerate your business.',
    icon: 'Database',
    featured: false,
  },
  {
    id: 'odoo-erp',
    title: 'Odoo ERP Solutions',
    description: 'Optimize your operations with customized Odoo ERP implementations.',
    icon: 'Settings',
    featured: false,
  },
  {
    id: 'custom-solutions',
    title: 'Custom & Tailored Solutions',
    description: 'Empower your business with our tailored eCommerce solutions.',
    icon: 'Lightbulb',
    featured: false,
  },
  {
    id: 'ecommerce',
    title: 'eCommerce Solutions',
    description: 'Grow your online business with customized eCommerce platforms.',
    icon: 'ShoppingCart',
    featured: false,
  },
] as const

export const PROCESS_STEPS = [
  {
    id: 'discover',
    title: 'Connect & Discover',
    description: 'We start by understanding your business goals and challenges.',
    image: '/images/2148040518.jpg',
  },
  {
    id: 'analyze',
    title: 'Analyze & Strategize',
    description: 'Deep dive into your requirements and create a strategic roadmap.',
    image: '/images/2149006892.jpg',
  },
  {
    id: 'design',
    title: 'Design & Develop',
    description: 'Build beautiful, functional solutions with cutting-edge technology.',
    image: '/images/2148176206.jpg',
  },
  {
    id: 'deliver',
    title: 'Deliver & Scale',
    description: 'Launch your solution and scale it as your business grows.',
    image: '/images/2149060246.jpg',
  },
] as const

export const PARTNERS = [
  { name: 'AWS', logo: '/images/SVGs/Amazon_Web_Services_Logo.svg' },
  { name: 'Google', logo: '/images/SVGs/Google_2015_logo.svg' },
  { name: 'Microsoft', logo: '/images/SVGs/Microsoft_logo_(2012).svg' },
  { name: 'Odoo', logo: '/images/SVGs/Component 42.svg' },
] as const

export const TESTIMONIALS = [
  {
    id: '1',
    name: 'Ammar Nizar',
    role: 'CEO @ Zoho',
    avatar: '/images/3735.jpg',
    quote: 'Working with DigiTrek has been an absolute pleasure. Their team delivered beyond our expectations.',
  },
  {
    id: '2',
    name: 'Omar Hamloul',
    role: 'CTO @ TechCorp',
    avatar: '/images/bf404d08198a86ab83b0df723bc84087.jpg',
    quote: 'The level of professionalism and technical expertise is outstanding. Highly recommended!',
  },
  {
    id: '3',
    name: 'Sarah Johnson',
    role: 'Product Manager @ StartupHub',
    avatar: '/images/a-chosen-soul-wZNJz5HVMGU-unsplash 1.png',
    quote: 'DigiTrek transformed our digital presence. The results speak for themselves.',
  },
  {
    id: '4',
    name: 'Ammar Nizar',
    role: 'CEO @ Zoho',
    avatar: '/images/3735.jpg',
    quote: 'Innovative solutions and exceptional support. They truly understand digital transformation.',
  },
  {
    id: '5',
    name: 'Omar Hamloul',
    role: 'CEO @ Zoho',
    avatar: '/images/bf404d08198a86ab83b0df723bc84087.jpg',
    quote: 'From concept to deployment, the entire process was seamless and efficient.',
  },
  {
    id: '6',
    name: 'Michael Chen',
    role: 'Founder @ InnovateLab',
    avatar: '/images/lawless-capture-S_28CdEI9iM-unsplash 1.png',
    quote: 'Their AI-powered solutions have revolutionized how we approach our business challenges.',
  },
] as const

export const FOOTER_LINKS = {
  navigation: [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/#services' },
    { label: 'About Us', href: '/#about' },
    { label: 'Portfolio', href: '/#portfolio' },
    { label: 'Contact', href: '/#contact' },
  ],
  services: [
    { label: 'Custom Software Development', href: '#services', id: 'custom-software' },
    { label: 'UI/UX Design Solutions', href: '#services', id: 'ui-ux-design' },
    { label: 'AI-Powered Solutions', href: '#services', id: 'ai-solutions' },
    { label: 'Enterprise Digital Transformation', href: '#services', id: 'enterprise-transformation' },
    { label: 'E-commerce & Marketplace Solutions', href: '#services', id: 'ecommerce-solutions' },
  ],
  social: [
    { name: 'Facebook', icon: '/images/SVGs/Shape.svg', url: 'https://facebook.com' },
    { name: 'LinkedIn', icon: '/images/SVGs/Group 14.svg', url: 'https://www.linkedin.com/company/digitrek-ae' },
    { name: 'Twitter', icon: '/images/SVGs/Twitter.svg', url: 'https://twitter.com' },
  ],
} as const

